import clsx from 'clsx';
import React from 'react';

export type ButtonVariant = 'green' | 'blue' | 'purple' | 'yellow' | 'red';
export type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
}

const variantClassMap: Record<ButtonVariant, string> = {
  green: 'green-button',
  blue: 'blue-button',
  purple: 'purple-button',
  yellow: 'yellow-button',
  red: 'red-button',
};

const sizeClassMap: Record<ButtonSize, string> = {
  xs: 'button-xs',
  sm: 'button-sm',
  md: 'button-md',
  lg: 'button-lg',
  xl: 'button-xl',
  '2xl': 'btn-2xl',
  '3xl': 'btn-3xl',
};

export function Button({
  variant = 'green', size = 'md', children, className, ...props
}: ButtonProps) {
  return (
    <button
      type="button"
      className={clsx(variantClassMap[variant], sizeClassMap[size], className)}
      {...props}
    >
      {children}
    </button>
  );
}
